import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { isArrayEmptyOrNull } from '../../utils/ObjectUtils';
import { executeDropInPaymentsCommands } from './command.action';
import { CommandFactory } from '../../commandManager/CommandFactory';
import { Namespace, DropInPaymentsCommandNames, fireStatusUpdate, StatusTypes, Component } from '@chegg/commerce-utils';
import { ERRORS } from '../../constants/Errors';
export var commandListener = function commandListener(middleware) {
  return middleware.startListening({
    actionCreator: executeDropInPaymentsCommands,
    effect: function () {
      var _effect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(action, _ref) {
        var getState, dispatch, state, commands;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              getState = _ref.getState, dispatch = _ref.dispatch;
              state = getState();
              commands = action.payload;
              if (!(!commands || isArrayEmptyOrNull(commands))) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              commands.forEach(function (commandInput) {
                var command = CommandFactory.createCommand({
                  input: commandInput,
                  dispatch: dispatch,
                  state: state
                });
                if (command) {
                  command.execute();
                } else {
                  fireStatusUpdate([{
                    status: StatusTypes.ERROR,
                    command: DropInPaymentsCommandNames.UNKNOWN_COMMAND,
                    payload: {
                      component: Component.COMMAND_MANAGER,
                      errors: [_objectSpread(_objectSpread({}, ERRORS.UNKNOWN_COMMAND_FAILURE), {}, {
                        message: "".concat(ERRORS.UNKNOWN_COMMAND_FAILURE.message, " ").concat(commandInput.commandName)
                      })]
                    }
                  }], Namespace.DROP_IN_PAYMENTS);
                }
              });
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function effect(_x, _x2) {
        return _effect.apply(this, arguments);
      }
      return effect;
    }()
  });
};
export default [commandListener];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/redux/command/command.listener.js
// module id = 4684
// module chunks = 11